import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderSl = () => {
    const isDesktop = useMediaQuery('(min-width: 540px)')

    return (
        <HighlightedText
            text="PREVZEMI SVOJ BONUS"
            highlights={[
                { word: 'PREVZEMI' },
                { word: 'SVOJ' },
                { word: 'BONUS' },
            ]}
            breakAfterWords={isDesktop ? [] : ['SVOJ']}
            className={common.text_header}
        />
    )
}

export const TextLandSl = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 BREZPLAČNIH VRTLJAJEV"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['Bonus', 'BREZPLAČNIH']}
            className={styles.text_content}
        />
    )
}
